<div class="wrap">
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.45)" size="medium" color="#fff" type="ball-scale-multiple" [fullScreen]="true">
        <p style="color: #fff">Generating report...</p>
    </ngx-spinner>
    <app-header></app-header>
    <div class="main-holder">
        <app-nav></app-nav>
        <div class="main">
            <div class="main-content">
                <div class="bread">
                    <ol>
                        <li><a [routerLink]="['/']"><img src="../../../../assets/okito/images/icons/home.svg"></a></li>
                        <img src="../../../../assets/okito/images/icons/chevron-right.svg">
                        <li><span>Transactions</span></li>
                    </ol>
                </div>
                <div class="content-title">
                    <h2>Transactions</h2>
                </div>
                <hr>
                <div class="list-tabs">
                    <ul>
                        <li [ngClass]="{'active': transTabs['express']}"><a (click)="tabCallFunction('express')" style="cursor: pointer;">Express</a></li>
                        <li [ngClass]="{'active': transTabs['okride']}"><a (click)="tabCallFunction('okride')" style="cursor: pointer;">OK! Ride</a></li>
                        <li [ngClass]="{'active': transTabs['mototaxi']}"><a (click)="tabCallFunction('mototaxi')" style="cursor: pointer;">OK! MotoTaxi</a></li>
                        <li [ngClass]="{'active': transTabs['oktaxi']}"><a (click)="tabCallFunction('oktaxi')" style="cursor: pointer;">OK! Taxi</a></li>
                    </ul>
                </div>

                <div class="cards">
                    <div class="row">
                        <div class="col-md">
                            <div class="card-item" [ngClass]="{'active': activeStatusFilter === 'all'}" (click)="filterByStatus('all')" style="cursor: pointer;">
                                <div class="card-content">
                                    <small>Total Transactions</small>
                                    <h4>{{ this.transactionList.length }}</h4>
                                </div>
                                <img src="../../../../assets/okito/images/card-icons/commission.svg">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="card-item" [ngClass]="{'active': activeStatusFilter === 'completed'}" (click)="filterByStatus('completed')" style="cursor: pointer;">
                                <div class="card-content">
                                    <small>Completed</small>
                                    <h4>{{ completeCount }}</h4>
                                </div>
                                <img src="../../../../assets/okito/images/card-icons/commission.svg">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="card-item" [ngClass]="{'active': activeStatusFilter === 'canceled'}" (click)="filterByStatus('canceled')" style="cursor: pointer;">
                                <div class="card-content">
                                    <small>Cancelled</small>
                                    <h4>{{ cancelledCount }}</h4>
                                </div>
                                <img src="../../../../assets/okito/images/card-icons/earnings.svg">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="card-item" [ngClass]="{'active': activeStatusFilter === 'ongoing'}" (click)="filterByStatus('ongoing')" style="cursor: pointer;">
                                <div class="card-content">
                                    <small>Ongoing</small>
                                    <h4>{{ ongoingCount }}</h4>
                                </div>
                                <img src="../../../../assets/okito/images/card-icons/payout.svg">
                            </div>
                        </div>
                        <div class="col-md">
                            <div class="card-item" [ngClass]="{'active': activeStatusFilter === 'pending'}" (click)="filterByStatus('pending')" style="cursor: pointer;">
                                <div class="card-content">
                                    <small>Pending</small>
                                    <h4>{{ pendingCount }}</h4>
                                </div>
                                <img src="../../../../assets/okito/images/card-icons/payout.svg">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="list-holder">
                    <div class="tools">
                        <div class="search mg-right-auto">
                            <img src="../../../../assets/okito/images/icons/magnifying.svg">
                            <input (input)="searchData($event)" [(ngModel)]="this.searchKeyword" type="text" class="text-search"
                                placeholder="Search">
                        </div>
                        <div class="search mg-right-auto" style="width:58%; ">
                            <span style="font-weight:bold;margin-right:10px;margin-left:20px;">Sorting: </span>
                            <select class="form-select" style="width:30%;margin-right:10px;" [(ngModel)]="transSortBy"
                                (ngModelChange)="onSortChange()">
                                <option value="dateCreated">Date Created</option>
                                <option value="status">Status</option>
                                <option value="totalPrice">Total Price</option>
                            </select>

                            <div class="btn-group" role="group" aria-label="Sort by.." style="width:5%;">
                                <button type="button" [ngClass]="{'active': transSortDirection === 'asc'}" class="btn btn-secondary"
                                    (click)="transSortDirection = 'asc'; onSortChange()">Ascending</button>
                                <button type="button" [ngClass]="{'active': transSortDirection === 'desc'}" class="btn btn-secondary"
                                    (click)="transSortDirection = 'desc'; onSortChange()">Descending</button>
                            </div>
                        </div>
                        <div class="actions">
                            <div class="filter-select" *ngIf="transTabs['oktaxi']" [ngClass]="{'open': fleetOperatorDropdownOpen}">
                                <button type="button" class="filter-select-toggle" (click)="toggleFleetOperatorDropdown()">
                                    <span class="filter-select-label">{{ fleetOperatorFilter || 'Fleet Operator' }}</span>
                                    <i class="fa fa-angle-down"></i>
                                </button>
                                <div class="filter-select-menu">
                                    <div class="filter-select-search">
                                        <img src="../../../../assets/okito/images/icons/magnifying.svg">
                                        <input type="text" class="filter-select-input" placeholder="Search Fleet Operator"
                                            [(ngModel)]="fleetOperatorSearch">
                                    </div>
                                    <ul class="filter-select-list">
                                        <li><a href="javascript:void(0)" [ngClass]="{'selected': selectedFleetId === ''}" (click)="selectFleetOperator('', '')">All Fleet Operators</a></li>
                                        <li *ngFor="let op of getFleetOperators()"><a href="javascript:void(0)" [ngClass]="{'selected': selectedFleetId === op.fleetId}" (click)="selectFleetOperator(op.fleetId, op.operatorName)">{{ op.operatorName }}</a></li>
                                    </ul>
                                    <p class="filter-select-empty" *ngIf="getFleetOperators().length === 0">No Fleet Operators found.</p>
                                </div>
                            </div>
                            <button class="btn btn-sm btn-default" (click)="this.downloadReport();">Download</button>
                        </div>
                    </div>
                    <div class="list table-responsive">
                        <table>
                            <thead>
                                <tr>
                                    <th>Transaction ID</th>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Partner Name</th>
                                    <th>Customer Name</th>
                                    <th *ngIf="transTabs['oktaxi']">Fleet Operator</th>
                                    <th>Type</th>
                                    <th>Total Price</th>
                                    <th>Status</th>
                                    <th>Options</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngIf="currentSelectedPageList.length != 0; else noRecordsMain">
                                <tr *ngFor="let trans of this.currentSelectedPageList">
                                    <td>{{ getTransactionId(trans) }}</td>
                                    <td>{{ trans.dateCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD' }}</td>
                                    <td>{{ trans.dateCreated | amFromUtc | amLocal | amDateFormat: 'h:mm A' }}</td>
                                    <td *ngIf="trans.partner; else noPartner">{{ trans.partner.firstName }} {{ trans.partner.middleName }} {{ trans.partner.lastName }}</td>
                                    <ng-template #noPartner><td>---</td></ng-template>
                                    <td *ngIf="trans.user; else noUser">{{ trans.user.name }}</td>
                                    <ng-template #noUser><td>---</td></ng-template>
                                    <td *ngIf="transTabs['oktaxi']">{{ getFleetOperatorName(trans) }}</td>
                                    <td>
                                        <span *ngIf="transTabs['express']">Express</span>
                                        <span *ngIf="transTabs['okride']">OK! Ride</span>
                                        <span *ngIf="transTabs['mototaxi']">OK! MotoTaxi</span>
                                        <span *ngIf="transTabs['oktaxi']">OK! Taxi</span>
                                    </td>
                                    <td>{{ trans.totalPrice | currency : 'PHP' }}</td>
                                    <td>
                                        <span class='stat stat-amend' *ngIf="trans.status == 'canceled'">Cancelled</span>
                                        <span class='stat stat-active' *ngIf="trans.status == 'pending'">Pending</span>
                                        <span class='stat stat-amend' *ngIf="trans.status == 'accepted'">Accepted</span>
                                        <span class='stat stat-amend' *ngIf="trans.status == 'ongoing_pickup'">On Going Pickup</span>
                                        <span class='stat stat-approved' *ngIf="trans.status == 'arrive_pickup'">Arrived Pickup</span>
                                        <span class='stat stat-approved' *ngIf="trans.status == 'ongoing_destination'">Ongoing Destination</span>
                                        <span class='stat stat-approved' *ngIf="trans.status == 'drop_off'">Drop Off</span>
                                        <span class='stat stat-approved' *ngIf="trans.status == 'completed'">Completed</span>
                                    </td>
                                    <td><a (click)="viewTransactionDetails(trans)" style="cursor: pointer;">View</a></td>
                                </tr>
                                </ng-container>
                                <ng-template #noRecordsMain>
                                    <tr>
                                        <td colspan="10" class="no-records-msg">
                                            <h6 class="ponds-contents-med-bold">No records found</h6>
                                        </td>
                                    </tr>
                                </ng-template>

                            </tbody>
                        </table>
                    </div>
                    <div class="list-footer">
                        <div class="pager">
                            <button (click)="nextPrev('prev')" [disabled]="this.disableActionBtns.prev"><img
                                    src="../../../../assets/okito/images/icons/prev.svg"></button>
                            <!-- <ol>
                                                                    <li *ngFor="let page of this.riderPages" style="cursor: pointer;" (click)="setPageSelected(page)"><a>{{ page
                                                                            }}</a></li>

                                                                </ol> -->
                            <button (click)="nextPrev('next')" [disabled]="this.disableActionBtns.next"><img
                                    src="../../../../assets/okito/images/icons/next.svg"></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
